import Stack from "./stack";

function DfsCursor(this: TODOAny) {
    this.depth = 0;
    this.stack = Stack({ node: null, index: -1 });
}

DfsCursor.prototype = {
    moveDown(node: TODOAny) {
        this.depth += 1;
        this.stack.push({ node, index: 0 });
    },

    moveUp() {
        this.depth -= 1;
        this.stack.pop();
    },

    moveNext() {
        this.stack.peek().index += 1;
    },

    get parent() {
        return this.stack.peek().node;
    },

    get index() {
        return this.stack.peek().index;
    },
};

export default function CursorFactory() {
    // this is legacy code. we don't want to rewrite it to a class right now.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new (DfsCursor as any)();
}
